import { IOpportunity } from '../../interfaces/nonprofitProfile/iOpportunity';
import { IOpportunityRole } from '../../interfaces/nonprofitProfile/iOpportunityRole';
import { IMember } from '../../interfaces/iMember';
import * as moment from 'moment';

export class Opportunity implements IOpportunity {
	public key: string;
	public title: string;
	public benefits: string;
	public currentMembers: number;
	public description: string;
	public apprxMonthlyTimeCommitment: number;
	public yearEstablished: number;
	public groupFundrasing: string;
	public meetingsPerYear: number;
	public membershipFee: number;
	public otherApplicationDetails: string;
	public expectedIndividualGiveGet: number;
	public responsibilities: string;
	public involvedMembers: IMember[];

	public isOpened: boolean;
	public type: string;
	public subType: string;
	public positionsAvailable: number;
	public termLength: number;
	public remoteFriendly: boolean;
	public externalApplicationLink: string;
	public applicationPeriodFlagId: number;
	// public applicationPeriodFromDate?: string;
	// public applicationPeriodToDate?: string;
	public recrutmentPreferences: string;
	public apprxMonthlyTimeCommitmentMin: number;
	public apprxMonthlyTimeCommitmentMax: number;

	public genderIdentity: string;
	public raceEthnicity: string;
	public skills: string;
	public groupActivityType: any[];
	public groupActivityRestriction: any[];
	public locationActivity?: string;
	public locationAddress?: string;
	public locationDetails?: string;
	public registrationOpenDate?: string;
	public registrationCloseDate?: string;
	public notificationFrequency: string;
	public notificationStatus: number;
	public rollingEnrollment: number;
	public priorityLevel: number;
	public repeatOption?: string;
  public repeatEvery?: string;
  public repeatOn?: string;
  public repeatEnd?: string;
	public isShortlisted?: Boolean;
	public shortlistedDate?: string;
	public expirationDate?: string;
	public daysUntilExpiry?: number;
	public organizationName?: string;
	public organizationLocation?: string;
	public imgUrl?: string;
	public isAllDay?: boolean;
	public startTime?: string;
	public endTime?: string;
	constructor(
		opportunity: IOpportunity = {} as IOpportunity
	) {
		this.title = opportunity.title;
		this.key = opportunity.key;
		this.benefits = opportunity.benefits;
		this.currentMembers = opportunity.currentMembers;
		this.description = opportunity.description;
		this.apprxMonthlyTimeCommitment = opportunity.apprxMonthlyTimeCommitment;
		this.yearEstablished = opportunity.yearEstablished;
		this.groupFundrasing = opportunity.groupFundrasing;
		this.meetingsPerYear = opportunity.meetingsPerYear;
		this.membershipFee = opportunity.membershipFee;
		this.otherApplicationDetails = opportunity.otherApplicationDetails;
		this.expectedIndividualGiveGet = opportunity.expectedIndividualGiveGet;
		this.responsibilities = opportunity.responsibilities;
		this.involvedMembers = opportunity.involvedMembers || [];

		this.isOpened = !!opportunity.isOpened || false;
		this.type = opportunity.type;

		this.subType = opportunity.subType;
		this.positionsAvailable = opportunity.positionsAvailable;
		this.termLength = opportunity.termLength;
		this.remoteFriendly = opportunity.remoteFriendly;
		this.externalApplicationLink = opportunity.externalApplicationLink;
		this.applicationPeriodFlagId = opportunity.applicationPeriodFlagId || 0;
		// this.applicationPeriodFromDate = opportunity.applicationPeriodFromDate;
		// this.applicationPeriodToDate = opportunity.applicationPeriodToDate;

		this.apprxMonthlyTimeCommitmentMin = opportunity.apprxMonthlyTimeCommitmentMin;
		this.apprxMonthlyTimeCommitmentMax = opportunity.apprxMonthlyTimeCommitmentMax;

		this.genderIdentity = opportunity.genderIdentity;
		this.raceEthnicity = opportunity.raceEthnicity;
		this.skills = opportunity.skills;
		this.groupActivityType = opportunity.groupActivityType;
		this.groupActivityRestriction = opportunity.groupActivityRestriction;
		this.locationActivity = opportunity.locationActivity;
		this.locationAddress = opportunity.locationAddress;
		this.locationDetails = opportunity.locationDetails;
		this.registrationOpenDate = opportunity.registrationOpenDate || moment(new Date().toISOString()).format('YYYY/MM/DD');
		this.registrationCloseDate = opportunity.registrationCloseDate || undefined;
		this.notificationFrequency = opportunity.notificationFrequency;
		this.notificationStatus = opportunity.notificationStatus;
		this.rollingEnrollment = opportunity.rollingEnrollment;
		this.priorityLevel = opportunity.priorityLevel;
		this.repeatOption = opportunity.repeatOption;
		this.repeatEvery = opportunity.repeatEvery;
		this.repeatOn = opportunity.repeatOn;
		this.repeatEnd = opportunity.repeatEnd;
		this.isShortlisted = opportunity.isShortlisted;
		this.shortlistedDate = opportunity.shortlistedDate;
		this.expirationDate = opportunity.expirationDate;
		this.daysUntilExpiry = opportunity.daysUntilExpiry;
		this.organizationLocation = opportunity.organizationLocation;
		this.organizationName = opportunity.organizationName;
		this.imgUrl = opportunity.imgUrl;
		this.isAllDay = opportunity.isAllDay;
		this.startTime = opportunity.startTime;
		this.endTime = opportunity.endTime;
	}

}


// WEBPACK FOOTER //
// ./static-content/private/javascripts/models/classes/nonprofitProfile/opportunity.ts